"use strict";
'use client';

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.listboxClasses = exports.Select = void 0;
var _react = require("react");
var _base = require("@mui/base");
var _Select = require("@mui/base/Select");
var _dom = require("@floating-ui/dom");
var _classVarianceAuthority = require("class-variance-authority");
var _helpers = require("../../common/helpers");
var _Icon = require("../Icon");
var _classes = require("../../common/classes");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["ownerState"],
  _excluded2 = ["helperText", "label", "id", "error", "size", "className"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var inputClasses = (0, _classVarianceAuthority.cva)(['flex', 'flex-row', 'gap-2', 'items-center', 'justify-between', 'w-full', 'outline', 'outline-1', 'px-4', 'py-2', 'focus:outline-2', 'rounded-lg', 'font-medium', 'my-3', 'transition-[outline-color]', 'duration-200'], {
  variants: {
    size: {
      sm: ['h-10'],
      md: ['h-[3.75rem]']
    },
    disabled: {
      "true": ['text-black/40', 'bg-gray-100', 'cursor-not-allowed'],
      "false": ['text-gray-700']
    },
    error: {
      "true": ['outline-danger', 'hover:enabled:outline-danger', 'hover:focus:enabled:outline-danger'],
      "false": ['outline-gray-200', 'focus:outline-primary', 'hover:focus:enabled:outline-primary']
    },
    open: {
      "true": [],
      "false": []
    }
  },
  compoundVariants: [{
    error: false,
    open: true,
    className: ['outline-2', 'outline-primary']
  }, {
    error: true,
    open: true,
    className: ['outline-2', 'outline-danger']
  }, {
    error: false,
    open: false,
    className: ['hover:enabled:outline-gray-700']
  }]
});
var listboxClasses = exports.listboxClasses = (0, _classVarianceAuthority.cva)(['bg-white', 'rounded-lg', 'w-full', 'border', 'border-gray-200', 'my-2', 'font-medium', 'text-gray-700']);
var SelectButton = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var ownerState = props.ownerState,
    other = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("button", _objectSpread(_objectSpread({
    type: "button"
  }, other), {}, {
    ref: ref,
    children: [other.children, /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
      icon: "chevron-down"
    })]
  }));
});

/**
 * Select - [API](https://reimagined-adventure-37999z9.pages.github.io/?path=/docs/inputs-select) | [DSM](https://sharphealthcare.notion.site/Inputs-4a77e695a529479fa701e2f3dcdc47e7#49e2612563204c958d34ed4ef4ee92aa)
 */
var Select = exports.Select = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var helperText = _ref.helperText,
    label = _ref.label,
    id = _ref.id,
    error = _ref.error,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'md' : _ref$size,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded2);
  var generatedID = (0, _react.useId)();
  var inputID = id !== null && id !== void 0 ? id : generatedID;
  var buttonRef = (0, _react.useRef)();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: className,
    children: [label && /*#__PURE__*/(0, _jsxRuntime.jsx)("label", {
      htmlFor: inputID,
      className: (0, _helpers.cn)((0, _classes.labelClasses)({
        disabled: Boolean(props.disabled),
        error: Boolean(error)
      })),
      children: label
    }), props.required && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      "aria-label": "required",
      className: (0, _helpers.cn)((0, _classes.requiredClasses)({
        disabled: Boolean(props.disabled)
      })),
      children: "*"
    }), helperText && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: (0, _helpers.cn)((0, _classes.helperClasses)()),
      children: helperText
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_base.ClassNameConfigurator, {
      disableDefaultClasses: true,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Select.Select, _objectSpread(_objectSpread({}, props), {}, {
        ref: ref,
        multiple: false,
        id: inputID,
        slots: {
          root: SelectButton
        },
        slotProps: {
          root: function root(inputState) {
            return {
              className: (0, _helpers.cn)(inputClasses({
                size: size,
                error: Boolean(error),
                disabled: Boolean(inputState.disabled),
                open: Boolean(inputState.open)
              })),
              ref: buttonRef,
              'aria-label': label
            };
          },
          listbox: {
            className: (0, _helpers.cn)(listboxClasses())
          },
          popup: {
            middleware: [(0, _dom.autoPlacement)(), (0, _dom.size)({
              apply: function apply(_ref2) {
                var rects = _ref2.rects,
                  elements = _ref2.elements;
                Object.assign(elements.floating.style, {
                  minWidth: 'fit-content',
                  width: "".concat(rects.reference.width, "px"),
                  zIndex: 1301
                });
              }
            })]
          }
        }
      }))
    }), error && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: (0, _helpers.cn)((0, _classes.errorClasses)()),
      children: error
    })]
  });
});